module.exports = __webpack_public_path__ + "static/media/icon_plus_in_circle.d6fabcc3.svg";